import { TuiIcon } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-version-available',
  imports: [TuiIcon],
  templateUrl: './version-available.component.html',
  styleUrl: './version-available.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionAvailableComponent {}
